import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  appointmentId: yup.number().required(),
  room: yup.string().required(),
  notes: yup.array().of(yup.number()).required(),
  customerNewNote: yup.string().nullable(),
  sendToProvider: yup.boolean().required(),
});

export function useAppointmentCheckinMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (payload) => {
      var req = requestSchema.validateSync(payload, { strict: true });

      return http.post(HTTP_ENDPOINTS.appointments.checkin(req.appointmentId), {
        id: req.appointmentId,
        room: req.room,
        notes_arr: req.notes,
        customer_new_note: req.customerNewNote,
        send_to_provider: req.sendToProvider,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        [
          QUERY_KEYS.appointments.appointment,
          QUERY_KEYS.appointments.checkin,
        ].forEach((key) => {
          queryClient.invalidateQueries({
            queryKey: [key],
          });
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
